
<div id="vesselFinderProps"></div>
<div #vesselFinderMap id="vesselFinderMap" tabindex="-1"></div>
